import {isArray, isObject} from "../../../../funcs";
import BaseRights from "../BaseRights";
import rightsByType from "../rightsByType";


export default class FormRights extends BaseRights {
    constructor() {
        super(...arguments);

        this.name = this.params.name;
        this.model = this.params.model;
        this._tmpAllow = this.params._tmpAllow;
    }

    _getTableName() {
        let table = this.params.table;

        // LW-5690 если форма не привязана ни к какому гриду
        // и в ней есть гриды, которые доступны только через эту форму
        // (т.е гриды, которые в этой форме не существуют отдельно)
        if ( this.formElem && this.formElem.form.params.manageRights ) {
            table = this.formElem.tableName;
        }

        // lw-4147 ищем права на родителя конкретного типа
        if ( table in rightsByType ) {
            for (let i = 0; i < rightsByType[table].length; i++) {
                let fieldType = Object.keys(rightsByType[table][i])[1];

                if ( rightsByType[table][i][fieldType] == this.model.get(fieldType) ) {
                    table = rightsByType[table][i]["TABLE"];
                    break;
                }
            }
        }

        // костыль,
        // TODO: сделать по другому, хз как
        let operationTableRegExp = /^OPERATION(_(SEA|AUTO|TRAIN|AIR|FORWARD|CUSTOMS))?$/;

        if ( operationTableRegExp.test(table) && isObject(this.model) ) {
            let operationModel = this.model;
            let operationTypeId = operationModel.get("ID_OPERATION_TYPE");

            if ( operationModel.get("IS_GROUP_COMBINER") == 1 ) {
                table = "OPERATION";
            } else if ( operationTypeId == 1 ) {
                table = table.replace(operationTableRegExp, "OPERATION_AUTO");
            } else if ( operationTypeId == 2 ) {
                table = table.replace(operationTableRegExp, "OPERATION_TRAIN");
            } else if ( operationTypeId == 3 ) {
                table = table.replace(operationTableRegExp, "OPERATION_SEA");
            } else if ( operationTypeId == 4 ) {
                table = table.replace(operationTableRegExp, "OPERATION_AIR");
            } else if ( operationTypeId == 5 ) {
                table = table.replace(operationTableRegExp, "OPERATION_REPACKING");
            } else if ( operationTypeId == 6 ) {
                table = table.replace(operationTableRegExp, "OPERATION_CUSTOMS");
            } else if ( operationTypeId == 7 ) {
                table = table.replace(operationTableRegExp, "OPERATION_FORWARD");
            } else if ( operationTypeId == 8 ) {
                table = table.replace(operationTableRegExp, "OPERATION_DOCUMENTATION");
            } else if ( operationTypeId == 9 ) {
                table = table.replace(operationTableRegExp, "OPERATION_OTHER");
            }
        }

        if ( table == "OPERATION_UNIT_SCOPE" ) {
            table = "OPERATION_UNIT";
        }
        if ( table == "LIST_GTD" ) {
            table = "LIST_ALL_GTD";
        }
        // LW-3484
        if ( table == "DOC_OPERATION_UNIT_LINK" ) {
            table = "DOC_OPERATION";
        }

        return table;
    }

    _getParentRightId(elemParams) {
        let path = [];

        let parentElem = elemParams.parentElem;

        // LW-5690
        // флаг 'manageRights' добавляется в apps/runs.js
        // нужен для форм, которые не привязаны к какому-либо гриду,
        // а доступны из меню например
        if ( elemParams.form && elemParams.form.params.manageRights ) {
            parentElem = elemParams.tableName + "." + elemParams.form2;
            return parentElem;
        }

        while (parentElem) {
            if ( parentElem.type == "Group" ) {
                path.unshift(parentElem.untranslatedTitle);
            } else if ( parentElem.type == "TabsHead" ) {
                path.unshift("head");
            } else if ( parentElem.type == "Tab" ) {
                let titleForRight = parentElem.generTabTitle ? parentElem.generTabTitle : parentElem.untranslatedTitle;
                path.unshift(titleForRight);
                path.unshift("tab");
            }

            parentElem = parentElem.parentElem;
        }

        path.unshift(this.name);
        path.unshift(this._getTableName());

        return path.join(".");
    }

    _checkElem(rule, parentId, elemParams) {
        if ( system.user.isAdmin() || this._tmpAllow ) {
            return true;
        }

        let rightId;

        // костыль, временный пропуск для прав)
        if ( elemParams._tmpAllow ) {
            return true;
        }

        // если на родителе галка, то все его потомки должны быть отмечены
        //
        // fix: если вкладка с одним элементом,
        // то в дереве для редактирования будет показан
        // только вкладка (без потомков)

        if ( parentId in this.manager.rights[rule] ) {
            return true;
        }

        if ( elemParams.type == "Group" ) {
            if ( !isArray(elemParams.elements) ) {
                return false;
            }

            rightId = parentId + "." + elemParams.untranslatedTitle;
            // среди elemParams.elements могут быть ClearBoth
            // а могут быть виртуальные элементы (без key)
            return this._checkTreeRight(rule, rightId);
        }

        if ( elemParams.type == "Grid" || elemParams.type == "GridCheckbox" ) {
            const gridTableName = elemParams.rightsTableName || elemParams.tableName;

            if ( !gridTableName ) {
                return true;
            }

            rightId = parentId + "." + gridTableName;
            return this._checkTreeRight(rule, rightId);
        }

        if ( elemParams.type == "Comments" ) {
            rightId = parentId + "." + (elemParams.eid || "comments");
            return this._checkTreeRight(rule, rightId);
        }

        if ( elemParams.type == "CheckboxList" || elemParams.type == "CheckboxListFromArray" ) {
            let chelistRightId = elemParams.eid || (elemParams.link && elemParams.link.table);

            if ( chelistRightId ) {
                rightId = parentId + "." + chelistRightId;
                return this._checkTreeRight(rule, rightId);
            }
        }

        if ( elemParams.type == "ArrivalPoints" ) {
            rightId = parentId + "." + (elemParams.eid || "arrival_points");
            return this._checkTreeRight(rule, rightId);
        }

        // simple elem
        if ( !elemParams.key ) {
            return true;
        }

        let table = this._getTableName();

        //if (rule == "edit") {
        const modules = Object.keys(system.modules);
        modules.push("All");
        for (let module of modules) {
            if (
                module in BaseRights.EMPTY_EXCLUSIVE
                    && table in BaseRights.EMPTY_EXCLUSIVE[module]
                    && BaseRights.EMPTY_EXCLUSIVE[module][table].includes(elemParams.key)
            ) {
                rightId = parentId + ".";

                let value = this.model.get(elemParams.key);

                if ( rule == "view" || value == null || (elemParams.type == "Checkbox" && value == 0) ) {
                    return (
                        this._checkTreeRight(rule, rightId + elemParams.key)
                            || this._checkTreeRight(rule, rightId + "EMPTY_EXCLUSIVE--" + elemParams.key)
                    );
                } else {
                    return this._checkTreeRight(rule, rightId + elemParams.key);
                }
            }
        }
        //}

        rightId = parentId + "." + elemParams.key;
        return this._checkTreeRight(rule, rightId);
    }

    _checkElement(rule, elemParams) {
        if ( system.user.isAdmin() || this._tmpAllow ) {
            return true;
        }

        if ( elemParams.type == "Tabs" ) {
            return true;
        }

        if ( elemParams._tmpAllow ) {
            return true;
        }

        const table = this._getTableName();

        // юзер-админ пока не может задать права, для операций с типом Иная, Перетарака, Документальная
        // поэтому пока разрешаем редактировать все поля в этих операциях
        if ( table in BaseRights.EXCLUDE_FROM_RIGHTS_FILTER ) {
            return true;
        }

        if ( !this.model.isVirtual() ) {
            const filter = this.getTableFilter(rule, table);

            if ( !filter.check(this.model) ) {
                return false;
            }
        }

        let parentId = "";

        parentId = this._getParentRightId(elemParams);
        return this._checkElem(rule, parentId, elemParams);
    }

    checkElementView(elemParams) {
        return this._checkElement("view", elemParams);
    }

    checkElementEdit(elemParams) {
        return this._checkElement("edit", elemParams);
    }

    _checkTab(rule, tabParams) {
        if ( system.user.isAdmin() || this._tmpAllow ) {
            return true;
        }

        if ( !tabParams.untranslatedTitle ) {
            return true;
        }

        // костыль, временный пропуск для прав)
        if ( tabParams._tmpAllow ) {
            return true;
        }

        let titleForRight = tabParams.generTabTitle ? tabParams.generTabTitle : tabParams.untranslatedTitle;
        let rightId = this._getTableName() + "." + this.name + ".tab." + titleForRight;
        return this._checkTreeRight(rule, rightId);
    }

    checkTabEdit(tabParams) {
        return this._checkTab("edit", tabParams);
    }

    checkTabView(tabParams) {
        return this._checkTab("view", tabParams);
    }

    checkReport(reportParams) {
        if ( system.user.isAdmin() || reportParams._tmpAllow ) {
            return true;
        }

        let rightId = this._getTableName() + "." + this.name + ".reports." + reportParams.report;
        return this._checkTreeRight("view", rightId);
    }

    checkButton(buttonParams) {
        if ( system.user.isAdmin() || this._tmpAllow ) {
            return true;
        }

        let rightId = this._getTableName() + "." + this.name + ".buttons." + buttonParams.bid;
        return this._checkTreeRight("view", rightId);
    }
}
